import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('LIKE').plugin(axiosPlugin);

let createLikeAction = redux.fetchActionCreate();

let deleteLikeAction = redux.fetchActionDelete();

redux.reducerForType('ADD', (state,payload) => {
    let newState = {...state};
    newState.data.unshift(payload.data);
    newState.total++;
    return newState;
});

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState.total--;
        if(newState.total < 0){
            newState.total = 0;
        }
    }
    return newState;
});

export const TYPES = redux.types;

export const createLike = (type, parentId) => createLikeAction(`/${type}/${parentId}/likes`);
export const deleteLike = (type, parentId) => deleteLikeAction(`/${type}/${parentId}/likes`);

export const like = redux.reducer();